import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"

import type { TowerAlertSetting } from "types/alerts.types"

import { useDeleteTowerAlertSettingMutation } from "features/api"
import { selectCurrentOrgId } from "features/store/orgSlice"
import { buildGetErrorMessage, snackbarMutation } from "helpers/utils/mutations"
import ConfirmationPopup from "widgets/common/ConfirmationPopup"

interface DeleteTowerAlertSettingProps {
  alertSetting: TowerAlertSetting
  open: boolean
  onClose: () => void
}

const DeleteTowerAlertSetting = ({
  alertSetting,
  open,
  onClose,
}: DeleteTowerAlertSettingProps) => {
  const { t } = useTranslation()
  const orgId = useSelector(selectCurrentOrgId)
  const [deleteTowerAlertSetting, { isLoading }] = useDeleteTowerAlertSettingMutation()

  const handleDeleteAlert = () => {
    snackbarMutation({
      mutation: deleteTowerAlertSetting({
        id: alertSetting.id,
        org_id: Number(orgId),
        towerId: alertSetting.entity_id,
      }).unwrap(),
      getErrorMessage: buildGetErrorMessage(
        t("error.DELETING_ITEM", { item: t("alert_settings.ALERT_SETTING") }),
      ),
      getSuccessMessage: () =>
        t("success.DELETING_ITEM", {
          item: t("alert_settings.ALERT_SETTING"),
          count: 1,
          context: "female",
        }),
    })
      .then(() => {
        onClose()
      })
      .catch(() => {})
  }

  return (
    <ConfirmationPopup
      open={open}
      onClose={onClose}
      description={t("alert_settings.ARE_YOU_SURE_TO_DELETE_SETTING", {
        alertName: alertSetting.config.custom_name,
      })}
      mainButtonText={t("alert_settings.DELETE_ALERT_SETTING")}
      onConfirm={handleDeleteAlert}
      isLoading={isLoading}
      isDeletePopup
    />
  )
}

export default DeleteTowerAlertSetting
